import React, {
  createContext,
  useContext,
  useEffect,
  ReactNode,
  useState,
  useCallback
} from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import Intercom from '@intercom/messenger-js-sdk';
import { isBounceWebview } from 'legacy/common/utils/webview';

interface IntercomContextType {
  hideIntercom: boolean;
  setHideIntercom: (hide: boolean) => void;
}

const IntercomContext = createContext<IntercomContextType | null>(null);

interface IntercomProviderProps {
  children: ReactNode;
}

export function IntercomProvider({ children }: IntercomProviderProps) {
  const router = useRouter();
  const user = useSelector((state: any) => state.user.user);
  const [hideIntercom, setHideIntercomState] = useState(false);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      user &&
      !window.Intercom &&
      !isBounceWebview(router.query)
    ) {
      Intercom({
        app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
        user_id: user._id,
        name: user.firstName,
        email: user.email,
        created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
        hide_default_launcher: hideIntercom
      });
    }
  }, [user]);

  const setHideIntercom = useCallback((hide: boolean) => {
    if (typeof window !== 'undefined' && window.Intercom) {
      (window.Intercom as any)('update', {
        hide_default_launcher: hide
      });
    }
    setHideIntercomState(hide);
  }, []);


  return (
    <IntercomContext.Provider value={{ hideIntercom, setHideIntercom }}>
      {children}
    </IntercomContext.Provider>
  );
}

export function useIntercom() {
  const context = useContext(IntercomContext);
  if (!context) {
    throw new Error('useIntercom must be used within IntercomProvider');
  }
  return context;
}
